var _defs, _rect, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompositeColumn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 170",
    width: 200,
    height: 170,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "steelSide",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2e3a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    stopColor: "#5a6f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#c0cfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82%",
    stopColor: "#5a6f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2e3a4a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "steelTop",
    cx: "44%",
    cy: "36%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#dce8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#7a90a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2e3a4a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "concTop",
    cx: "42%",
    cy: "38%",
    r: "58%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e2e5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8a8f96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rebarSide",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c3200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#e08020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7c3200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rebarTop",
    cx: "35%",
    cy: "30%",
    r: "65%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffd060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7c3200"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "hatch",
    x: 0,
    y: 0,
    width: 6,
    height: 6,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 6,
    x2: 6,
    y2: 0,
    stroke: "#444",
    strokeWidth: 0.4,
    opacity: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 50,
    width: 160,
    height: 80,
    fill: "url(#steelSide)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20,130 A 80,20 0 0 0 180,130",
    fill: "url(#steelSide)",
    stroke: "#1e2a38",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 50,
    rx: 80,
    ry: 20,
    fill: "url(#steelTop)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 50,
    rx: 75,
    ry: 18.75,
    fill: "url(#concTop)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 50,
    rx: 75,
    ry: 18.75,
    fill: "url(#hatch)",
    opacity: 0.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 50,
    rx: 3.5,
    ry: 0.875,
    fill: "url(#rebarTop)",
    stroke: "#7c3200",
    strokeWidth: 0.7
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130,
    cy: 37.82,
    rx: 3.5,
    ry: 0.875,
    fill: "url(#rebarTop)",
    stroke: "#7c3200",
    strokeWidth: 0.7
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 37.82,
    rx: 3.5,
    ry: 0.875,
    fill: "url(#rebarTop)",
    stroke: "#7c3200",
    strokeWidth: 0.7
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 50,
    rx: 3.5,
    ry: 0.875,
    fill: "url(#rebarTop)",
    stroke: "#7c3200",
    strokeWidth: 0.7
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 62.18,
    rx: 3.5,
    ry: 0.875,
    fill: "url(#rebarTop)",
    stroke: "#7c3200",
    strokeWidth: 0.7
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130,
    cy: 62.18,
    rx: 3.5,
    ry: 0.875,
    fill: "url(#rebarTop)",
    stroke: "#7c3200",
    strokeWidth: 0.7
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 50,
    rx: 80,
    ry: 20,
    fill: "none",
    stroke: "#1e2a38",
    strokeWidth: 1.4
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 50,
    rx: 75,
    ry: 18.75,
    fill: "none",
    stroke: "#4a5f72",
    strokeWidth: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 50,
    x2: 20,
    y2: 130,
    stroke: "#1e2a38",
    strokeWidth: 1.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 50,
    x2: 180,
    y2: 130,
    stroke: "#1e2a38",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompositeColumn);
export default __webpack_public_path__ + "static/media/composite_column.a45a5e16ab31a5e99ff85edcbd5fceac.svg";
export { ForwardRef as ReactComponent };